import { HiOutlineUserGroup } from 'react-icons/hi2'
import Avatar from './Avatar'

export type TopSalesEntry = {
  id: number
  name: string
  lead_count: number
}

type Props = {
  entries: TopSalesEntry[]
  /** Maximum number of users to display. Defaults to 3. */
  limit?: number
}

export default function TopSalesCard({ entries, limit = 3 }: Props) {
  const visible = entries.slice(0, limit)

  return (
    <div className="flex flex-col overflow-hidden rounded-xl bg-white shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.06)]">
      <div className="flex items-center gap-2 border-b border-[#f5f5f5] px-5 py-3">
        <HiOutlineUserGroup className="h-5 w-5 text-ink" aria-hidden="true" />
        <h3 className="font-display text-lg font-medium tracking-tight text-ink">Top Sales</h3>
      </div>

      <div className="flex flex-col gap-1 px-6 py-4">
        {visible.length === 0 ? (
          <p className="py-4 text-center font-display text-sm text-gray-500">No leads assigned yet.</p>
        ) : (
          visible.map((entry, index) => (
            <div key={entry.id} className="flex items-center gap-3 py-2">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#EEF1F6] font-display text-base font-medium text-black">
                {index + 1}
              </span>
              <div className="flex min-w-0 flex-1 items-center gap-2">
                <Avatar id={entry.id} name={entry.name} size="md" />
                <p className="truncate font-display text-sm text-ink">{entry.name}</p>
              </div>
              <p className="shrink-0 font-display text-ink">
                <span className="text-lg font-medium">{entry.lead_count}</span>
                <span className="ml-1 text-base font-medium">leads</span>
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
